import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { BaseContentControlWrapper } from '../../../components/ContentControlWrapper.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExamAccessIssueScreen = () => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-default",
    children: /*#__PURE__*/_jsxs(ErrorMessage, {
      illustration: "keys",
      illustrationProps: {
        width: 200
      },
      title: /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.exams.requiredScopeError.heading"
        })
      }),
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.exams.requiredScopeError.body"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.exams.requiredScopeError.explainer"
        })
      })]
    })
  }), /*#__PURE__*/_jsx(BaseContentControlWrapper, {
    borderStyle: "none",
    children: /*#__PURE__*/_jsx(Button, {
      disabled: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.examQuestion.nextButton"
      })
    })
  })]
});
export default ExamAccessIssueScreen;